// extracted by mini-css-extract-plugin
export var cell = "ComparisonTable-module--cell--1a5f8";
export var cell1 = "ComparisonTable-module--cell1--ede96";
export var cell2 = "ComparisonTable-module--cell2--0f56c";
export var cell3 = "ComparisonTable-module--cell3--cbe01";
export var cell4 = "ComparisonTable-module--cell4--fc8e0";
export var cell5 = "ComparisonTable-module--cell5--6053a";
export var cgutter = "ComparisonTable-module--cgutter--50d92";
export var cgutter4 = "ComparisonTable-module--cgutter4--7c908";
export var cgutter5 = "ComparisonTable-module--cgutter5--1f896";
export var fgutter = "ComparisonTable-module--fgutter--00c2b";
export var fgutter1 = "ComparisonTable-module--fgutter1--7abdb";
export var fgutter2 = "ComparisonTable-module--fgutter2--4adbb";
export var fgutter3 = "ComparisonTable-module--fgutter3--d1b81";
export var fgutter4 = "ComparisonTable-module--fgutter4--13755";
export var fgutter5 = "ComparisonTable-module--fgutter5--0ffc7";
export var header = "ComparisonTable-module--header--5115c";
export var header1 = "ComparisonTable-module--header1--b3d6d";
export var header2 = "ComparisonTable-module--header2--7d06b";
export var header3 = "ComparisonTable-module--header3--c3083";
export var header4 = "ComparisonTable-module--header4--3bca9";
export var header5 = "ComparisonTable-module--header5--b34d4";
export var hgutter = "ComparisonTable-module--hgutter--4badf";
export var hgutter1 = "ComparisonTable-module--hgutter1--ac281";
export var hgutter2 = "ComparisonTable-module--hgutter2--f221b";
export var hgutter3 = "ComparisonTable-module--hgutter3--0e008";
export var hgutter4 = "ComparisonTable-module--hgutter4--4b53e";
export var hgutter5 = "ComparisonTable-module--hgutter5--47beb";
export var table = "ComparisonTable-module--table--fd453";